import React, {useState, useEffect} from 'react';
import NotificationTab from './SubComponents/NotificationTab';
import Breadcrumb from '../Common/Breadcrumb/Breadcrumb';
import {Col, Row} from 'react-bootstrap';
import {httpRequest} from "../../httpRequest";
import {CircularProgress} from "@material-ui/core";
import './Notifications.scss';

export default function Notifications(props) {
  const covrServicesBaseUrl = process.env.REACT_APP_COVR_SERVICES_URL;

  const [notifications, setNotifications] = useState([]);
  const [notificationsLoading, setNotificationsLoading] = useState(false);

  useEffect(() => {
    setNotificationsLoading(true);

    httpRequest.get(`${covrServicesBaseUrl}/api/Notification/Get`).then((data) => {
      setNotifications(data);
      setNotificationsLoading(false);
    }).catch((err) => console.log(err));
  }, []);

  const renderNotifications = () => {
    const hasNotifications = notifications && notifications.length >= 1;

    if (notificationsLoading) {
      return <div className="d-flex justify-content-center p-5"><CircularProgress/></div>;
    }

    if (hasNotifications) {
      return <NotificationTab notifications={notifications} setActiveLink={props.setActiveLink} navLinks={props.navLinks} setNotifications = {value => setNotifications(value)} history={props.history}/>;
    }

    return <React.Fragment>
      <h4>No notifications to display.</h4>
      <p> As you use the platform, any relevant information will be displayed here.</p>
    </React.Fragment>;
  }

  return (
    <React.Fragment>
      <div className="mb-4">
        <Breadcrumb breadcrumbLinks={[{name: 'HOME', href: '/'}]} currentPage={'NOTIFICATIONS'}/>
      </div>
      <Row className="mb-4">
        <Col sm='auto'>
          <h1>Notifications</h1>
        </Col>
      </Row>
      {renderNotifications()}
    </React.Fragment>
  )
}


// WEBPACK FOOTER //
// ./src/components/Notifications/Notifications.js